import { Helmet } from "react-helmet";
import {texts} from "../../texts";

export const HomeHelmet = () => {
    return (
        <Helmet>
            <title>{texts.main.title}</title>
        </Helmet>
    )
}